import { AutogenModelOrderPostHist, AutogenRowOrderPostHist } from "./autogen/AutogenModelOrderPostHist";

export class ModelOrderPostHist extends AutogenModelOrderPostHist<RowOrderPostHist> {
    constructor() {
        super(RowOrderPostHist);
    }
}

export class RowOrderPostHist extends AutogenRowOrderPostHist {
}